
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/[activitySlug]",
      function () {
        return require("private-next-pages/games/[activitySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/[activitySlug]"])
      });
    }
  